import React from 'react'
import NumberFormat from 'react-number-format'
import { Card } from 'components/ui'

const ACCENT = {
  emerald: 'bg-emerald-500/10 text-emerald-400 ring-emerald-500/30',
  amber: 'bg-[#ffcc58]/10 text-[#ffcc58] ring-[#ffcc58]/30',
}

/**
 * One headline figure: icon + label, the number, and a caption saying what it
 * counts. `currency` prefixes a small "USD"; leave it off for counts.
 * `accent="amber"` flags a figure that needs the admin's attention.
 * `children` render under the caption, e.g. a breakdown of the figure.
 */
const StatCard = ({ icon, label, value, caption, currency, loading, accent = 'emerald', children }) => (
  <Card bordered>
    <div className="flex items-center gap-3">
      <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-xl ring-1 ring-inset ${ACCENT[accent]}`}>
        {icon}
      </div>
      <span className="text-sm font-semibold text-gray-300">{label}</span>
    </div>
    {loading ? (
      <div className="mt-4 h-8 w-36 rounded bg-gray-700/60 animate-pulse" />
    ) : (
      <div className="mt-4 flex items-baseline gap-1.5">
        {currency && <span className="text-sm font-semibold text-gray-500">{currency}</span>}
        <NumberFormat
          displayType="text"
          value={value || 0}
          thousandSeparator
          decimalScale={currency ? 2 : 0}
          fixedDecimalScale={!!currency}
          className="text-2xl xl:text-3xl font-bold text-gray-100 tabular-nums"
        />
      </div>
    )}
    {caption && <div className="mt-1 text-xs text-gray-500">{caption}</div>}
    {!loading && children}
  </Card>
)

export default StatCard
